import { render, staticRenderFns } from "./classes.vue?vue&type=template&id=98432842&scoped=true&"
import script from "./classes.vue?vue&type=script&lang=js&"
export * from "./classes.vue?vue&type=script&lang=js&"
import style0 from "./classes.vue?vue&type=style&index=0&id=98432842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98432842",
  null
  
)

export default component.exports